<div class="FooterContainer flex-col flex-center">
    <ng-content></ng-content>
</div>
